import { useState } from 'react';
import {
  Button,
  Modal,
  Form,
  Spinner
} from 'react-bootstrap';

const PriceConatainer = (props) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const selectCurrency = (e) => {
    props.onSelectCurrency(e.currentTarget.querySelector('.modal-currency-symbol').innerText,
                          e.currentTarget.querySelector('.modal-currency-name').innerText);
    handleClose();
  }

  return (
    <>
      <div
        className='px-3 py-3'
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%'
        }}
      >
        <div className='modal-currency-symbol'>
          {props.currencies.find(v => v.symbol === props.selectedCurrency).symbol}
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            height: '100%',
            justifyContent: 'space-between'
          }}
        >
          <div style={{fontWeight: 700, fontSize: 18}}>
            {props.currencies.find(v => v.symbol === props.selectedCurrency).title}
          </div>
        {props.isCalculatingPrice ? (
          <div
            style={{
              display: "inline",
              marginRight: "4px"
            }}
          >
            <Spinner size="sm" animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        ) : props.price.price} {props.selectedCurrency}
        </div>
        <Form.Label
          onClick={handleShow}
          style={{
            cursor: 'pointer',
            height: '100%',
            display: 'flex',
            alignItems: 'center'
          }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#ffcd04" class="bi bi-arrow-right-square-fill currency-chevron" viewBox="0 0 16 16">
            <path d="M0 14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v12zm4.5-6.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5a.5.5 0 0 1 0-1z"/>
          </svg>
        </Form.Label>
      </div>

      <Modal className="currencies-modal" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <h5>SELECT CHECKOUT CURRENCY</h5>
        </Modal.Header>
        <Modal.Body>
          {props.currencies.map((val) => (
            <div
              className="modal-currency-container"
              key={'currency_selector_item_key_' + val.symbol}
              onClick={selectCurrency}
            >
              <span className="modal-currency-symbol">{val.symbol}</span>
              <span className="modal-currency-name">{val.title}</span>
            </div>
          ))}
        </Modal.Body>
      </Modal>
    </>
  );
}

export default PriceConatainer;
